import TraceInfo from '@/service/traceinfo'
import RequestUtils from './requestUtils.js'

export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    gettracingenvinfos(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(TraceInfo.gettracingenvinfos(payload), {
        type: 'list',
        success,
        fail
      })
    },
    gettracingenvinfo(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(TraceInfo.gettracingenvinfo(payload), {
        type: 'info',
        success,
        fail
      })
    },
    addtracingenvinfo(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(TraceInfo.addtracingenvinfo(payload), {
        type: 'action',
        success,
        fail
      })
    },
    updatetracingenvinfo(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(TraceInfo.updatetracingenvinfo(payload), {
        type: 'action',
        success,
        fail
      })
    },
    deletetracingenvinfo(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(TraceInfo.deletetracingenvinfo(payload), {
        type: 'action',
        success,
        fail
      })
    },
    gettracingenvinfotemplate(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(TraceInfo.gettracingenvinfotemplate(payload), {
        type: 'info',
        success,
        fail
      })
    }
  }
}
